<template>
  <v-autocomplete
    id="temas-select"
    v-model="municipioid"
    :items="values"
    label="Municípios"
    placeholder="Selecione..."
    v-on:change="$emit('onChange', municipioid)"
    :disabled="disabled"
    :clearable="false"
    item-value="municipioId"
    item-text="nome"
    :rules="rules"
  >
    <template slot="no-data"> Nenhum Município retornado </template>
  </v-autocomplete>
</template>

<script>
import { cityAPI } from "@/modules/city";

export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    loadCities() {
      cityAPI.list().then((resp) => {
        this.values = resp.data;
        this.municipioid = this.values.filter(
          (item) => item.municipioId == this.$route.params.id
        )[0];
      });
    },
  },
  mounted() {
    this.loadCities();
    console.log("this.$route.params.id: ", this.$route.params.id);
  },

  data() {
    return {
      values: [],
      municipioid: this.$route.params.id,
    };
  },
};
</script>
